<mat-dialog-content class="medlem-invitasjon-rediger-dialog-innhold">
  <medlem-invitasjon-rediger [invitasjon]="invitasjon"
                             [gruppe]="gruppe"
                             (vedLagret)="vedLagret()"
                             (vedAvbryt)="avbryt()"/>
</mat-dialog-content>
